// Council of  Enactus 6.0 imports
// import Member1 from "../../Assets/Members/Member1.png";
// import Member2 from "../../Assets/Members/Akshat.jpeg";
// import Tanya from "../../Assets/Members/Member2.png";
// import Mehak from "../../Assets/Members/Member4.png";
// import Member4 from "../../Assets/Members/Sridisha.jpeg";
// import Member14 from "../../Assets/Members/Tanya.jpeg";
// import Devanshi from "../../Assets/Members/Devanshi.jpeg";
// import Faculty from "../../Assets/Members/Faculty.jpeg";

// Council of  Enactus 7.0 imports
// import Anushka from "../../Assets/Members-7.0/Anushka Khanduri.jpeg";
// import Simran from "../../Assets/Members-7.0/Simran Dhankar.jpeg";
// import Yashi from "../../Assets/Members-7.0/Yashi Tomar.JPG";
// import Devansh from "../../Assets/Members-7.0/Devansh Arya .jpg";
// import Sparsh from "../../Assets/Members-7.0/Sparsh.jpeg";
// import TanyaK from "../../Assets/Members-7.0/Tanya.jpeg";
// import Sridisha from "../../Assets/Members-7.0/Sridisha.jpeg";

// Council of  Enactus 7.0 imports

import Vibhor from "../img/vibhor.jpg"
import Tanishka from "../img/tanishka.jpeg.jpg"
import Divyansh from "../img/divyansh.png"
import PreetiMaam from "../img/Preeti.jpg"


// Data list of enactus 6.0
// const Data6 = [
//   {
//     image: Member2,
//     name: "Akshat Dhaundiyal",
//     position: "President",
//   },
//   {
//     image: Member4,
//     name: "Sridisha Padhy",
//     position: "Vice President",
//   },
//   {
//     image: Devanshi,
//     name: "Devanshi",
//     position: "Head of external affairs",
//   },
//   {
//     image: Member14,
//     name: "Tanya Kapoor",
//     position: "General Secretary",
//   },
//   {
//     image: Member1,
//     name: "Kritika Gogia",
//     position: "Senior Advisory",
//   },
//   {
//     image: Tanya,
//     name: "Tanya Nischal",
//     position: "Senior Advisory",
//   },
//   {
//     image: Mehak,
//     name: "Mehak Gulati",
//     position: "Senior Advisory",
//   },
//   {
//     image: Faculty,
//     name: "Trina Som",
//     position: "Faculty",
//   },
// ];

// Data list of enactus 6.0
// const Data = [
//   {
//     image: Anushka,
//     name: "Anushka Khanduri",
//     position: "President",
//   },
//   {
//     image: Simran,
//     name: "Simran Dhankar",
//     position: "Vice President",
//   },
//   {
//     image: Yashi,
//     name: "Yashi Tomar",
//     position: "Head of external affairs",
//   },
//   {
//     image: Devansh,
//     name: "Devansh Arya",
//     position: "General Secretary",
//   },
//   {
//     image: Member2,
//     name: "Akshat Dhaundiyal",
//     position: "Senior Advisory",
//   },
//   {
//     image: Sridisha,
//     name: "Sridisha Padhy",
//     position: "Senior Advisory",
//   },
//   {
//     image: Sparsh,
//     name: "Sparsh Girdhar",
//     position: "Senior Advisory",
//   },
//   {
//     image: TanyaK,
//     name: "Tanya Kapoor",
//     position: "Senior Advisory",
//   },
//   {
//     image: Faculty,
//     name: "Trina Som",
//     position: "Faculty",
//   },
// ];

const Data = [
  {
    image: Vibhor,
    name: "Vibhor Jain",
    position: "President",
  },
  {
    image: Tanishka,
    name: "Tanishka Gaur",
    position: "Vice President",
  },
  {
    image: Divyansh,
    name: "Divyansh Karakoti",
    position: "General Secretary & PR Head",
  },
  {
    image: PreetiMaam,
    name: "Preeti Dhaka",
    position: "Faculty Coordinator",
  },
];
export default Data;